export const toArray = (value) => {
  if (Array.isArray(value)) return value;
  if (!value || typeof value !== "object") return [];
  const candidates = [
    value.data?.body?.data,
    value.data?.body,
    value.body?.data,
    value.data?.data,
    value.data?.items,
    value.data?.list,
    value.body,
    value.data,
    value.items,
    value.list,
  ];
  return candidates.find(Array.isArray) || [];
};

export const getTotal = (value, fallback) =>
  Number(
    value?.data?.body?.total ??
      value?.data?.total ??
      value?.body?.total ??
      value?.total ??
      fallback ??
      0
  );
